<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
	<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<div class="mdc-layout-grid__inner center d-flex align-items-center justify-content-center m-3">
	<div class="mdc-layout-grid__cell--span-12 mb-2">
		<img class="paymentPageImg" [src]="'/assets/images/payment/transfer-complete.svg' | s3Image" class="img-responsive" />
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<span class="text-center fs-20px fw-500 d-block mb-2">{{ locale.translations['payment']['n615'] }}</span>
		<span class="text-center fs-14px fg-grey d-block">{{ locale.translations['payment']['n616'] }}</span>
	</div>

	<div class="row w-100" *ngIf="!embedded">
		<div class="col-6 px-1">
			<button mat-stroked-button type="button" class="cancel-btn px-1 w-100 fw-400" color="primary" (click)="onNo()">
				{{ locale.translations['payment']['n617'] }}
			</button>
		</div>

		<div class="col-6 px-1">
			<button mat-flat-button type="submit" class="px-1 w-100 fw-400" color="primary" (click)="onYes()">
				{{ locale.translations['payment']['n618'] }}
			</button>
		</div>
		<button cdkFocusInitial hidden></button>
	</div>
</div>
